import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ButtonModule',
  components: {
    Loading
  },
  data () {
    return {
      loading: false
    }
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapState({
      active: state => state.sclButtonModule.active,
      values: state => state.sclButtonModule.values,
      isModify: state => state.sclButtonModule.isModify
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    textAlignmentList () {
      return Constants.Layout.TextAlignment
    },
    roundCornerList () {
      return Constants.Layout.RoundCorner.sort(Utility.sortByKey('index', true))
    },
    btnLayoutTypeList () {
      return Constants.Layout.Button.LayoutType
    },

    // input
    posX: {
      get () {
        return this.values.posX
      },
      set (value) {
        this.setInputValue({
          keys: ['posX'],
          value: value
        })
      }
    },
    posY: {
      get () {
        return this.values.posY
      },
      set (value) {
        this.setInputValue({
          keys: ['posY'],
          value: value
        })
      }
    },
    width: {
      get () {
        return this.values.width
      },
      set (value) {
        this.setInputValue({
          keys: ['width'],
          value: value
        })
      }
    },
    height: {
      get () {
        return this.values.height
      },
      set (value) {
        this.setInputValue({
          keys: ['height'],
          value: value
        })
      }
    },
    btnLayoutType: {
      get () {
        return this.values.btnLayoutType
      },
      set (value) {
        this.setInputValue({
          keys: ['btnLayoutType'],
          value: value
        })
      }
    },
    margin: {
      get () {
        return this.values.margin
      },
      set (value) {
        this.setInputValue({
          keys: ['margin'],
          value: value
        })
      }
    },
    btnLabelFontSize: {
      get () {
        return this.values.btnLabelFontSize
      },
      set (value) {
        this.setInputValue({
          keys: ['btnLabelFontSize'],
          value: value
        })
      }
    },
    btnLabelCharCountUpperLimit: {
      get () {
        return this.values.btnLabelCharCountUpperLimit
      },
      set (value) {
        this.setInputValue({
          keys: ['btnLabelCharCountUpperLimit'],
          value: value
        })
      }
    },
    labelAlignment: {
      get () {
        return this.values.labelAlignment
      },
      set (value) {
        this.setInputValue({
          keys: ['labelAlignment'],
          value: value
        })
      }
    },
    roundCornerFlg: {
      get () {
        return this.values.roundCornerFlg
      },
      set (value) {
        this.setInputValue({
          keys: ['roundCornerFlg'],
          value: value
        })
      }
    },
    roundCornerLeftTop: {
      get () {
        return this.values.rectRoundCornerStyle.roundCornerLeftTop
      },
      set (value) {
        this.setInputValue({
          keys: ['rectRoundCornerStyle', 'roundCornerLeftTop'],
          value: value
        })
      }
    },
    roundCornerRightTop: {
      get () {
        return this.values.rectRoundCornerStyle.roundCornerRightTop
      },
      set (value) {
        this.setInputValue({
          keys: ['rectRoundCornerStyle', 'roundCornerRightTop'],
          value: value
        })
      }
    },
    roundCornerLeftBottom: {
      get () {
        return this.values.rectRoundCornerStyle.roundCornerLeftBottom
      },
      set (value) {
        this.setInputValue({
          keys: ['rectRoundCornerStyle', 'roundCornerLeftBottom'],
          value: value
        })
      }
    },
    roundCornerRightBottom: {
      get () {
        return this.values.rectRoundCornerStyle.roundCornerRightBottom
      },
      set (value) {
        this.setInputValue({
          keys: ['rectRoundCornerStyle', 'roundCornerRightBottom'],
          value: value
        })
      }
    },

    // validate
    disablePostButton () {
      if (this.filterMode === 0) return false
        return false
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      hide: 'sclButtonModule/hide',
      reset: 'sclButtonModule/reset',
      setLayer: 'screenConfigLayout/setLayer',
      removeLayer: 'screenConfigLayout/removeLayer'
    }),
    ...mapMutations({
      setInputValue: 'sclButtonModule/setInputValue'
    }),

    init () {
      // this.loading = true
    },

    /**
     * レイヤー情報を設定
     */
    postData () {
      this.setLayer(this.values)
      this.hide()
    },
    /**
     * レイヤー情報を削除
     */
    removeData () {
      this.removeLayer(this.values)
      this.hide()
    },

    /**
     * テキストエリアでEnterキー押下の処理
     */
    onKeydownEnter(keyCode) {
      if (keyCode !== 13) return
      this.postData()
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}